import { computed, IComputedValue } from 'mobx';

const getSurfaceGridPixelsPerMinuteRatioComputed: IComputedValue<number> = computed(() => {
    // VSO 131234: Consume time scale calendar setting
    return 1;
});

export default function getSurfaceGridPixelsPerMinuteRatio(): number {
    return getSurfaceGridPixelsPerMinuteRatioComputed.get();
}
